import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../../config";
import { useHistory } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

const SelfAppraisalList = () => {
  const history = useHistory();
  const [rows, setRows] = useState([]);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/self-appraisal/list`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })
      .then((res) => setRows(res.data.data || []))
      .catch(() => toast.error("Failed to load list"));
  }, []);

  return (
    <div className="card">
      <ToastContainer />

      <div className="card-header">
        <h5>Self Appraisal List</h5>
      </div>

      <div className="card-body">
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>S.no</th>
              <th>Request Date</th>
              <th>Score</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 && (
              <tr>
                <td colSpan="4" className="text-center">
                  No records
                </td>
              </tr>
            )}

            {rows.map((row, i) => (
              <tr key={row.request_id}>
                <td>{i + 1}</td>
                <td>{row.request_date}</td>
                <td>{row.total_score ?? "--"}</td>
                <td>
                  {row.is_answerd === 1 ? (
                    <span className="text-success"></span>
                  ) : (
                    <button
                      className="btn btn-danger btn-sm"
                      onClick={() =>
                        history.push(
                          `/SelfAppraisalEvaluate/${row.request_id}` // ✅ PASS ID
                        )
                      }
                    >
                      Evaluate
                    </button>
                  )}
                   {row.is_answerd === 1 && (
                    <button
                      className="btn btn-danger btn-sm"
                      onClick={() =>
                        history.push(
                          `/SelfAppraisalScore/${row.summary_id}`
                        )
                      }
                    >
                      View
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SelfAppraisalList;
